import React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  Link,
  Breadcrumbs,
  InputAdornment,
  TextField,
  Stack,
  Button,
  Grid,
  AppBar,
} from "@mui/material";

import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useSelector } from "react-redux";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { schedulegdata } from "../../assets/Griddata";
import { externalgetApi } from "../../services/external/externalApis";
import {
  SETTINGS_API_04,
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
} from "../../api/ApiModel";
import SearchAppBar from "../../components/common/search";

function ViewSchedule() {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };
  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (ORDERSTSCODE) => handleItemClick(ORDERSTSCODE, "Edit"),
    },
  ];
  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.ORDERSTSCODE === id);
      if (selectedItem) {
        navigate(`/OrderTracking`, { state: { selectedItem, actionText } });
      }
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" href="/">
                  Home
                </Link>
                {/* <Link underline="none">Setting</Link> */}
                <Link underline="none">View Schedule</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => navigate("/Schedules")}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <ViewData
        columns={schedulegdata.columns}
        rows={filteredData.map((item) => ({ ...item, id: item.ORDERSTSCODE }))}
        menuItems={menuItems}
        tabletitle={schedulegdata.name}
        gridid="ORDERSTSCODE"
      />
    </div>
  );
}

export default ViewSchedule;
